var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "title-coinatiner"
  }, [_c('capusta-title', {
    attrs: {
      "title": _vm.displayTitle,
      "history-mode": ""
    }
  }), _vm.isShownHelpLink ? _c('help-link', {
    attrs: {
      "source": _vm.currentTab.helpLink
    }
  }) : _vm._e()], 1), _vm.isShownTabs ? _c('div', {
    staticClass: "tabs-container"
  }, _vm._l(_vm.filteredTabs, function (tab) {
    return _c('capusta-tab', {
      key: "tab_".concat(tab.key),
      attrs: {
        "tab": tab,
        "active": _vm.activeTabKey === tab.key
      },
      on: {
        "click": function click($event) {
          return _vm.onChangeTab(tab.key);
        }
      }
    });
  }), 1) : _vm._e()]), _vm.isShownForm ? _c('div', {
    staticClass: "form-container"
  }, [_c(_vm.componentsMap[_vm.activeTabKey], {
    tag: "component",
    attrs: {
      "transaction": _vm.transaction
    },
    on: {
      "showInfo": _vm.onShownInfo,
      "submit": _vm.onSubmit
    }
  })], 1) : _vm._e(), _c('bill-information-modal', {
    model: {
      value: _vm.isShownInfo,
      callback: function callback($$v) {
        _vm.isShownInfo = $$v;
      },
      expression: "isShownInfo"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }